import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import '../components/marquee';
// import '../components/marquee-logo';
import { navbarScroll, menuLang } from '../layout';
import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", function(){
	navbarScroll();
	menuLang();
});

// cache
const cacheModal = document.querySelector('.cache');
const cacheBtn = document.querySelector('.cache__btn');
if (!localStorage.getItem("modalShown")) {
	cacheModal.style.display = "block";
	localStorage.setItem("modalShown", "true");
}
cacheBtn.addEventListener("click", function () {
	cacheModal.remove();
});

// banner slider
const bannerSwiper = new Swiper(".banner__swiper", {
	modules: [Navigation, Pagination, Autoplay],
	spaceBetween: 0,
	centeredSlides: true,
	loop: true,
	autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
	pagination: {
	  	el: ".banner .swiper-pagination",
	  	clickable: true,
	},
	navigation: {
	  	nextEl: ".banner .swiper-button-next",
	  	prevEl: ".banner .swiper-button-prev",
	},
});


// highlight slider
var swiperThumb = new Swiper(".highlight-thumb", {
	spaceBetween: 10,
	slidesPerView: 4,
	freeMode: true,
});
var swiperHighlight = new Swiper(".highlight-swiper", {
	modules: [Thumbs, Pagination, Autoplay],
	spaceBetween: 10,
	autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
	pagination: {
		el: ".highlight__pagination",
		// type: "progressbar",
		clickable: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiperThumb,
	}
});

// business slider
var swiperBusiness = new Swiper(".business-solution__swiper", {
	modules: [Pagination],
	spaceBetween: 30,
	slidesPerView: 1,
	loop: true,
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		992: {
			slidesPerView: 3,
			spaceBetween: 20,
			allowTouchMove: true,
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: 30,
			allowTouchMove: false,
		},
		1400: {
			slidesPerView: 5,
			spaceBetween: 30,
			allowTouchMove: false,
		}
	},
	pagination: {
		el: ".business-solution__pagination",
		clickable: true,
	},
}); 
const businessLists = document.querySelectorAll('.business-list--mobile');
businessLists.forEach(businessList => {
	if (window.innerWidth < 992) {
		businessList.remove();
	}
})
swiperBusiness.update();

// review slider
// var reviewThumb = new Swiper(".review-thumb", {
// 	spaceBetween: 30,
// 	slidesPerView: 2,
// 	freeMode: true,
// 	centeredSlides: true,
// 	loop: true,
// 	breakpoints: {
// 		576: {
// 			slidesPerView: 3,
// 		},
// 		768: {
// 			slidesPerView: 2,
// 		},
// 		991: {
// 			centeredSlides: false,
// 		},
// 		1200: {
// 			slidesPerView: 3,
// 			spaceBetween: 30,
// 			centeredSlides: false,
// 		}
// 	},
// });
// var reviewSwiper = new Swiper(".review-swiper", {
// 	modules: [Thumbs],
// 	spaceBetween: 10,
// 	navigation: {
// 		nextEl: ".swiper-button-next",
// 		prevEl: ".swiper-button-prev",
// 	},
// 	thumbs: {
// 		swiper: reviewThumb,
// 	},
// });